__turbopack_context__.v({
  "allArticles": "ratgeber-module-scss-module__K4CQHG__allArticles",
  "bigDesktopPageWidth": "ratgeber-module-scss-module__K4CQHG__bigDesktopPageWidth",
  "desktopPageWidth": "ratgeber-module-scss-module__K4CQHG__desktopPageWidth",
  "divider": "ratgeber-module-scss-module__K4CQHG__divider",
  "featuredArticlesSection": "ratgeber-module-scss-module__K4CQHG__featuredArticlesSection",
  "ratgeberArticleCardOnIndexPage": "ratgeber-module-scss-module__K4CQHG__ratgeberArticleCardOnIndexPage",
  "ratgeberArticleImageContainer": "ratgeber-module-scss-module__K4CQHG__ratgeberArticleImageContainer",
  "ratgeberArticles": "ratgeber-module-scss-module__K4CQHG__ratgeberArticles",
  "ratgeberArticlesContainer": "ratgeber-module-scss-module__K4CQHG__ratgeberArticlesContainer",
  "ratgeberFeaturedArticlesContainer": "ratgeber-module-scss-module__K4CQHG__ratgeberFeaturedArticlesContainer",
  "ratgeberIntro": "ratgeber-module-scss-module__K4CQHG__ratgeberIntro",
  "ratgeberPage": "ratgeber-module-scss-module__K4CQHG__ratgeberPage",
  "ratgeberPageTitle": "ratgeber-module-scss-module__K4CQHG__ratgeberPageTitle",
  "root": "ratgeber-module-scss-module__K4CQHG__root",
  "sanitized": "ratgeber-module-scss-module__K4CQHG__sanitized",
  "sanitizedHtml": "ratgeber-module-scss-module__K4CQHG__sanitizedHtml",
  "threeLineEllipse": "ratgeber-module-scss-module__K4CQHG__threeLineEllipse",
});
